var date = {};
module["exports"] = date;
date.month = require("./month");
date.weekday = require("./weekday");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/date/index.js
 ** module id = 362
 ** module chunks = 0
 **/